import React from 'react'
import { preview } from './Preview.module.css';
import { element, node, oneOfType } from 'prop-types';

const Preview = ({ children }) => <div className={preview}>{children}</div>

Preview.propTypes = {
  children: oneOfType([element, node]),
}

Preview.defaultProps = {
  children: null,
}

export default Preview